import dayjs from "utils/dates/dayjsex";

export const DEFAULT_INVITE_LINK_EXPIRY_DURATION = dayjs.duration(7, "days");
